import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';
import { filesAPI } from 'src/api/modules/files';
import UtilInputs from 'src/common/components/UtilInputs';
export const rechazarArchivo = (
	id_archivo,
	archivo,
	resolucion,
	id_organo,
	motivo,
	callback,
	setIsLoadingResponse,
	setOpen
) => {
	const data = {
		id_organo: id_organo,
		id_archivo: id_archivo,
		resolucion: resolucion,
		motivoR: motivo,
		archivo: archivo,
	};
	filesAPI
		.rechazarArchivo(data)
		.then((response) => {
			notice('Notificación enviada correctamente', 'success');
			if (callback) callback();
			if (
				window.location.href.search('seguimiento/resolucion') > -1 ||
				window.location.href.search('seguimiento/inclusion-temas') > -1
			) {
				window.location.reload();
			}
		})
		.catch((err) => {
			notice(
				'No se pudo enviar la notificación, contacte al administrador del sistema',
				'error'
			);
		})
		.finally(() => {
			setIsLoadingResponse(false);
			setOpen(false);
		});
};

export const ModalRechazoArchivo = ({ open, setOpen, data, updateView = false }) => {
	const [motivoRechazo, setmotivoRechazo] = useState({ rechazo: '' });
	const [isLoadingResponse, setIsLoadingResponse] = useState(false);
	const rechazar = (id_archivo, archivo, resolucion, id_organo, motivo) => {
		setIsLoadingResponse(true);
		rechazarArchivo(
			id_archivo,
			archivo,
			resolucion,
			id_organo,
			motivo,
			() => {
				if (updateView !== false) {
					updateView();
				} else {
					setmotivoRechazo({ rechazo: '' });
				}
			},
			setIsLoadingResponse,
			setOpen
		);
	};

	const handleChange = (e) => {
		let { name, value } = e.target;
		setmotivoRechazo({ ...motivoRechazo, [name]: value });
	};
	return (
		<BaseModal
			open={open}
			onConfirm={() => {
				rechazar(
					data.id_archivo,
					data.archivo,
					data.resolucion,
					data.id_organo,
					motivoRechazo.rechazo
				);
			}}
			onClose={() => setOpen(false)}
			mainText="Rechazar Archivo"
			onCancel={() => setOpen(false)}
			confirmLabel="Guardar"
			disableOnConfirm={isLoadingResponse}
		>
			<Grid item md={12}>
				<UtilInputs
					onValuesChange={handleChange}
					formValues={motivoRechazo}
					inputValues={[
						{
							label: 'Motivo Rechazo',
							name: 'rechazo',
							type: 'text',
						},
					]}
				/>
			</Grid>
		</BaseModal>
	);
};
